module.exports = __webpack_public_path__ + "img/big_11B07_blue.2592fa6e.png";